import React, { Component } from 'react';
import { connect } from 'react-redux';
import QRCode from 'qrcode.react';

import Cookies from 'universal-cookie';
const cookies = new Cookies();

import {
  fetchSecurity,
  activateOTP,
  enableOTP,
  disableOTP,
  validatePwd,
  signOut
} from '../../actions';

class Otp extends Component {
  constructor(props) {
    super(props);

    this.state = {
      yubiKeyOtp: '',
      token: '',
      passwordValidator: '',
      resetCode: '',
      use2fa: false,
      useYubi: false,
      validationToken: '',
      manualYubiKey: false,
    };
    this.validateOTP = this.validateOTP.bind(this);
    this.disableOTP = this.disableOTP.bind(this);
    this.handleTokenChange = this.handleTokenChange.bind(this);
    this.handlePasswordValidatorChange = this.handlePasswordValidatorChange.bind(this);
    this.validatePwd = this.validatePwd.bind(this);
    this.toggleYubikeyListener = this.toggleYubikeyListener.bind(this);
    this.captureYubiKey = this.captureYubiKey.bind(this);
    this.toggleYubiKeyManual = this.toggleYubiKeyManual.bind(this);
    this.handleBackupSaved = this.handleBackupSaved.bind(this);
  }

  componentDidMount() {
    const { user, resetCode } = this.props;
    let yubiEnabled;

    if (user.security) {
      const yubiHandle = user.security.find(e => e.typeHandle === 'YUBIKEY');
      if (yubiHandle && yubiHandle.statusHandle === 'ACTIVATED') {
        yubiEnabled = true;
      }
    }

    if (yubiEnabled && !resetCode) {
      this.toggleYubikeyListener('ENABLE');
    }
  }

  componentWillUnmount() {
    this.toggleYubikeyListener('DISABLE');
  }

  toggleYubikeyListener(type) {
    if (type === 'ENABLE') {
      document.addEventListener('keypress', this.captureYubiKey, false);
    }
    if (type === 'DISABLE') {
      document.removeEventListener('keypress', this.captureYubiKey, false);
    }
  }

  toggleYubiKeyManual() {
    const { manualYubiKey } = this.state;
    if (!manualYubiKey) {
      this.toggleYubikeyListener('DISABLE');
    } else {
      this.toggleYubikeyListener('ENABLE');
    }
    this.setState({manualYubiKey: !manualYubiKey, yubiKeyOtp: ''})
  }

  captureYubiKey(e) {
    const { user } = this.props;
    const { yubiKeyOtp } = this.state;

    let yubiEnabled;

    if (user.security) {
      const yubiHandle = user.security.find(e => e.typeHandle === 'YUBIKEY');
      if (yubiHandle && yubiHandle.statusHandle === 'ACTIVATED') {
        yubiEnabled = true;
      }
    }

    if (e.which === 13 || e.key === 'Enter') {
      if (yubiEnabled) {
        this.disableOTP(e);
        return;
      }
      this.validateOTP(e);
      return;
    }
    let useYubikey = '' + e.key;
    if (yubiKeyOtp) {
      useYubikey = yubiKeyOtp + e.key;
    }
    this.setState({yubiKeyOtp: useYubikey});
  }

  validateOTP(event) {
    event.preventDefault();
    const { dispatch } = this.props;
    const { token, useYubi, yubiKeyOtp, validationToken } = this.state;


    let data = {
      token,
      type: 'validateOTP',
    }

    if (useYubi) {
      data = {
        token: validationToken,
        type: 'enableYubiKey',
        yubiKeyOtp,
      }
    }

    dispatch(activateOTP(data)).then((res) => {
      if (res.type === 'ACTIVATE_OTP_SUCCESS') {
        this.toggleYubikeyListener('DISABLE');
        dispatch(fetchSecurity());
      }
      if (res.type === 'ACTIVATE_OTP_FAIL') {
        this.setState({yubiKeyOtp: ''});
      }
    });
  }

  disableOTP(event) {
    event.preventDefault();
    const { dispatch, user } = this.props;
    const { token, yubiKeyOtp } = this.state;

    let otpEnabled;
    let yubiEnabled;

    if (user.security) {
      const otpHandle = user.security.find(e => e.typeHandle === 'OTP');
      if (otpHandle && otpHandle.statusHandle === 'ACTIVATED') {
        otpEnabled = true;
      }
      const yubiHandle = user.security.find(e => e.typeHandle === 'YUBIKEY');
      if (yubiHandle && yubiHandle.statusHandle === 'ACTIVATED') {
        yubiEnabled = true;
      }
    }


    let data = {
      token,
      type: 'disableOTP',
    }

    if (yubiEnabled) {
      data = {
        yubiKeyOtp,
        type: 'disableYubiKey',
      }
    }

    dispatch(disableOTP(data)).then((res) => {
      if (res.type === 'DISABLE_OTP_SUCCESS') {
        this.props.toggleModal(null);
      }
      dispatch(fetchSecurity());
    });
  }

  handleTokenChange(event) {
    this.setState({ [event.target.id]: event.target.value });
  }

  handleBackupSaved(){
    const { dispatch, history } = this.props;
    dispatch(signOut(cookies, history)).then(() => {
      window.location.href = '/';
    });
  }

  handlePasswordValidatorChange(event) {
    this.setState({ passwordValidator: event.target.value });
  }

  async validatePwd(event) {
    event.preventDefault();
    const { dispatch } = this.props;
    const { passwordValidator, use2fa, useYubi } = this.state;
    const data = {
      password: passwordValidator,
      type: 'validatePassword',
    };
    await dispatch(validatePwd(data))
    .then((res) => {
      if (res.type === 'VALIDATE_PASSWORD_SUCCESS') {
        if (res.payload.token) {
          this.setState({
            validationToken: res.payload.token,
          });
          if (useYubi) {
            this.toggleYubikeyListener('ENABLE');
          }
        }
      }
    });

    if (use2fa) {
      const { user } = this.props;
      if (user && user.pwdToken) {
        const { dispatch } = this.props;
        const data = {
          token: user.pwdToken,
          type: 'enableOTP'
        };
        dispatch(enableOTP(data));
      }
    }
  }

  render() {
    const { user, resetCode } = this.props;
    const { token, passwordValidator, use2fa, useYubi, yubiKeyOtp, validationToken, manualYubiKey } = this.state;

    let otpEnabled;
    let yubiEnabled;

    if (user.security) {
      const otpHandle = user.security.find(e => e.typeHandle === 'OTP');
      if (otpHandle && otpHandle.statusHandle === 'ACTIVATED') {
        otpEnabled = true;
      }
      const yubiHandle = user.security.find(e => e.typeHandle === 'YUBIKEY');
      if (yubiHandle && yubiHandle.statusHandle === 'ACTIVATED') {
        yubiEnabled = true;
      }
    }

    if ((otpEnabled || yubiEnabled) && resetCode) {
      return (
        <div className="cell small-12 medium-12 large-12">
          <div className="modal-title">
            Two-Factor Setup
          </div>
          <div className="grid-x">
            <div className="cell small-12 medium-12 large-12">
              <div className="modal-heading">Save Your Backup Token</div>
              <div className="modal-subheading">
                Please save your backup token below now.
                <br />
                {otpEnabled && (
                  'You will need this to access your account if you lose access to your Authenticator.'
                )}
                {yubiEnabled && (
                  'You will need this to access your account if you lose access to your YubiKey.'
                )}
              </div>
            </div>
            <div className="cell small-12 medium-12 large-12">
              <h2>{resetCode}</h2>
            </div>

            <div className="cell small-12 medium-12 large-12 modal-actions">
              <button className="vlt-button" type="submit" onClick={() => this.handleBackupSaved()}>
                <span>
                  I have saved my backup token
                </span>
              </button>
            </div>
          </div>
        </div>
      );
    }

    if ((otpEnabled || yubiEnabled) && !resetCode) {
      return (
        <div className="cell small-12 medium-12 large-12">
          <div className="modal-title">
            Two-Factor Setup
          </div>
          <div className="grid-x">
            <div className="cell small-12 medium-12 large-12">
              <div className="modal-heading">Disable Two-Factor Authentication</div>
              <div className="modal-subheading">
                {otpEnabled && (
                  'Please enter your authenticator code below.'
                )}
                {yubiEnabled && (
                  <>
                    1. Insert your YubiKey into a USB port
                    <br />
                    {manualYubiKey ? (
                      '2. Enter your YubiKey code in the field below'
                    ) : (
                      '2. Touch the YubiKey button'
                    )}
                  </>
                )}
              </div>
            </div>
            <div className="cell small-12 medium-12 large-12">
              <form onSubmit={this.disableOTP} id="form1" autoComplete="off">
                {otpEnabled && (
                  <input id="token" className="modal-input" type="text" name="token" placeholder="Enter Auth Token" value={token} autoComplete="off" onChange={this.handleTokenChange} autoFocus />
                )}
                {yubiEnabled && (
                  <>
                    <div>
                      <img alt="YubiKeys" src={ process.env.REACT_APP_CDN + '/assets/images/yubikeys.png'} style={{maxWidth: '80%', marginBottom: '20px'}}/>
                    </div>
                    {manualYubiKey ? (
                      <div>
                        <input id="yubiKeyOtp" className="modal-input" type="password" name="yubiKeyOtp" placeholder="Enter YubiKey" value={yubiKeyOtp} autoComplete="off" onChange={this.handleTokenChange} autoFocus />
                      </div>
                    ) : null}
                  </>
                )}
              </form>
            </div>

            <div className="cell small-12 medium-12 large-12 modal-actions">
              <button className="button" type="submit" onClick={() => this.props.toggleModal(null)}>
                <span>
                  Cancel
                </span>
              </button>
              {otpEnabled && (
                <button className="vlt-button" type="submit" form="form1" disabled={!token}>
                  <span>
                    Confirm
                  </span>
                </button>
              )}
              {yubiEnabled && (
                <>
                  {manualYubiKey ? (
                    <button className="vlt-button" type="submit" form="form1" disabled={!yubiKeyOtp}>
                      <span>
                        Confirm
                      </span>
                    </button>
                  ) : (
                    <button className="button" type="submit" onClick={this.toggleYubiKeyManual}>
                      <span>
                        Enter Manually
                      </span>
                    </button>
                  )}
                </>
              )}
            </div>
          </div>
        </div>
      );
    }

    if (use2fa) {
      return (
        <div className="cell small-12 medium-12 large-12">
          <div className="modal-title">
            Two-Factor Setup
          </div>
          <div className="grid-x">
            <div className="cell small-12 medium-12 large-12">
              <div className="modal-heading">
                { user.otpPath ? 'Enable Two-Factor Authentication' : 'Confirm Your Password' }
              </div>
              <div className="modal-subheading">
                { user.otpPath ? 'Please enter your auth token.' : 'Please enter your password.' }
              </div>
            </div>
            <div className="cell small-12 medium-12 large-12">
              { user.otpPath ? (
                <div>
                  <QRCode value={user.otpPath} style={{marginBottom:16}}/>
                  <form onSubmit={this.validateOTP} id="form1" autoComplete="off">
                    <input id="token" className="modal-input" type="text" name="token" placeholder="Enter Auth Token" value={token} onChange={this.handleTokenChange} autoFocus autoComplete="off" />
                  </form>
                </div>
              ) : (
                <form onSubmit={this.validatePwd} id="form1">
                  <input className="modal-input" type="password" name="token" placeholder="Enter Password" value={passwordValidator} onChange={this.handlePasswordValidatorChange} autoFocus />
                </form>
              ) }
            </div>

            <div className="cell small-12 medium-12 large-12 modal-actions">
              <button className="button" type="submit" onClick={() => this.props.toggleModal(null)}>
                <span>
                  Cancel
                </span>
              </button>
              <button className="vlt-button" type="submit" form="form1" disabled={user.otpPath ? !token : !passwordValidator}>
                <span>
                  Verify
                </span>
              </button>
            </div>
          </div>

        </div>
      );
    }

    if (useYubi) {
      return (
        <div className="cell small-12 medium-12 large-12">
          <div className="modal-title">
            Two-Factor Setup
          </div>
          <div className="grid-x">
            <div className="cell small-12 medium-12 large-12">
              <div className="modal-heading">
                { validationToken ? 'Enable Yubikey 2FA' : 'Confirm Your Password' }
              </div>
              <div className="modal-subheading">
                { validationToken ? (
                  <>
                    1. Insert your YubiKey into a USB port
                    <br />
                    {manualYubiKey ? (
                      '2. Enter your YubiKey code in the field below'
                    ) : (
                      '2. Touch the YubiKey button'
                    )}
                  </>
                ) : (
                  'Please enter your password.'
                ) }
              </div>
            </div>
            <div className="cell small-12 medium-12 large-12">
              { validationToken ? (
                <>
                  <div>
                    <img alt="YubiKeys" src={ process.env.REACT_APP_CDN + '/assets/images/yubikeys.png'} style={{maxWidth: '80%', marginBottom: '20px'}}/>
                  </div>
                  {manualYubiKey ? (
                    <div>
                      <form onSubmit={this.validateOTP} id="form1" autoComplete="off">
                        <input id="yubiKeyOtp" className="modal-input" type="password" name="yubiKeyOtp" placeholder="Yubico One-Time Password" value={yubiKeyOtp} onChange={this.handleTokenChange} autoFocus autoComplete="off" />
                      </form>
                    </div>
                  ) : null}
                </>
              ) : (
                <form onSubmit={this.validatePwd} id="form1">
                  <input className="modal-input" type="password" name="token" placeholder="Enter Password" value={passwordValidator} onChange={this.handlePasswordValidatorChange} autoFocus />
                </form>
              ) }
            </div>

            <div className="cell small-12 medium-12 large-12 modal-actions">
              <button className="button" type="submit" onClick={() => this.props.toggleModal(null)}>
                <span>
                  Cancel
                </span>
              </button>
              { validationToken ? (
                <>
                  {manualYubiKey ? (
                    <button className="vlt-button" type="submit" form="form1" disabled={validationToken ? !yubiKeyOtp : !passwordValidator}>
                      <span>
                        Verify
                      </span>
                    </button>
                  ) : (
                    <button className="button" type="submit" onClick={this.toggleYubiKeyManual}>
                      <span>
                        Enter Manually
                      </span>
                    </button>
                  )}
                </>
              ) : (
                <>
                  <button className="vlt-button" type="submit" form="form1" disabled={!passwordValidator}>
                    <span>
                      Verify
                    </span>
                  </button>
                </>
              )}
            </div>
          </div>

        </div>
      );

    }

    return (
      <div className="cell small-12 medium-12 large-12">
        <div className="modal-title">
          Two-Factor Setup
        </div>
        <div className="grid-x">
          <div className="cell small-12 medium-12 large-12">
            <div className="modal-heading">Select 2FA Type</div>
            <div className="modal-subheading">
              Please select whether you want to use a 2FA app or Yubikey.
            </div>
          </div>
          <div className="cell small-12 medium-12 large-12">
            <div className="button-area lr-b">
              <button className="vlt-button" type="submit" onClick={() => this.setState({use2fa: true})}>
                <span>
                  2FA App
                </span>
              </button>
              <button className="vlt-button" type="submit" onClick={() => this.setState({useYubi: true})}>
                <span>
                  Yubikey
                </span>
              </button>
            </div>
          </div>

          <div className="cell small-12 medium-12 large-12 modal-actions">
            <button className="button" type="submit" onClick={() => this.props.toggleModal(null)}>
              <span>
                Cancel
              </span>
            </button>
          </div>
        </div>

      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  user: state.user,
  errors: state.user.errors,
  resetCode: state.user.resetCode,
});

export default connect(mapStateToProps)(Otp);
